<div class="secure-amount">
  <div class="secure-amount__title">
    Total disponible
    <div class="secure-amount__amount-integer" data-recording-sensitive>
      {{ buyingPowerAmountIntegers | hbCustomFormat: '$0,0' }}
      <span class="secure-amount__amount-cents">
        .{{ buyingPowerAmountCents }}
      </span>
    </div>
  </div>
  <div class="secure-amount__distribution">
    <div class="row">
      Disponible para comprar
      <div class="secure-amount__distribution--amount" data-recording-sensitive>
        {{ buyingPowerSecureAmount | hbCustomFormat: '$0,0.00' }}
      </div>
      <div class="secure-amount__distribution--percentage">99.5%</div>
    </div>
    <div class="row">
      Seguridad para sobregiros
      <div class="secure-amount__distribution--amount" data-recording-sensitive>
        {{ buyingPowerMarginAmount | hbCustomFormat: '$0,0.00' }}
      </div>
      <div class="secure-amount__distribution--percentage">0.5%</div>
    </div>
  </div>
  <div class="secure-amount__description">
    <div class="secure-amount__description--title">
      ¿Por qué el Disponible para comprar es menor al Total disponible?
    </div>
    <div class="secure-amount__description--detail">
      Debido a la variación del precio de los instrumentos y/o tipo de cambio,
      se mantendrá el 0.5% del Total disponible en un apartado de seguridad para
      reducir el riesgo de presentar un sobregiro y cubrir posiciones futuras
    </div>
    <div class="secure-amount__description--title">¿Qué es un sobregiro?</div>
    <div class="secure-amount__description--detail">
      Es el monto que rebasa el disponible para comprar en tu estrategia,
      generando un saldo negativo y una deuda
    </div>
  </div>
</div>
